<template>
  <div class="external-component4">
  </div>
</template>

<script>
const d3 = Object.assign({}, require('d3-request'), require('d3-selection'), require('d3-scale'), require('d3-array'), require('d3-axis'), require('d3-time-format'), require('d3-shape'), require('d3-format'))

export default {
  props: ['attributes'],
  methods: {
    initCode (value) {
      // d3.tsv('https://gist.githubusercontent.com/xaquingv/842166a4c7f45c8331ef903f686cacc6/raw/f66017db625515ced54b6bcb8faeef1ef7e9939f/data_wuhan.tsv', rawData => {
      d3.json('https://s3-st-graphics-json.s3-ap-southeast-1.amazonaws.com/2019-ncov/timeseries.json', rawData => {
        const parseTime = d3.timeParse('%Y-%m-%d')

        let china = rawData.filter(d => d.country === 'China')
        const others = rawData.filter(d => d.country !== 'China' && 'country' in d)

        china = china.map(d => ({date: parseTime(d.date), cases: +d.cases, area: 'China'}))

        let othersSummarized = d3.rollups(others, v => d3.sum(v, d => d.cases), d => d.date)

        othersSummarized = othersSummarized.map(d => ({date: parseTime(d[0]), cases: +d[1], area: 'Others'}))

        var margin = {top: 30, right: 30, bottom: 30, left: 40}
        var clientWidth = this.$el.clientWidth > 600 ? this.$el.clientWidth * 0.5 : this.$el.clientWidth
        var width = clientWidth - margin.left - margin.right // Use the window's width
        var height = clientWidth * 0.8 - margin.top - margin.bottom // Use the window's height

        var linechart = d3.select(this.$el)
                .append('div')
                .attr('id', 'linechartWrapper')

        function drawChart (data) {
        // The number of datapoints
          const yMax = data[0].cases

          // 5. X scale will use the index of our data
          var xScale = d3.scaleTime()
                .domain(d3.extent(data, d => d.date)) // input
                .range([0, width]) // output

          // 6. Y scale will use the randomly generate number
          var yScale = d3.scaleLinear()
                .domain([0, yMax]) // input
                .range([height, 0])

          var xAxis = d3.axisBottom(xScale).ticks(5).tickFormat(d3.timeFormat('%-m/%-d'))
          var yAxis = d3.axisRight(yScale)
                    .ticks(5)
                    .tickSize(width)
                    .tickFormat(d3.format(',.0f'))

          // 7. d3's line generator
          var line = d3.line()
                .x(function (d) { return xScale(d.date) }) // set the x values for the line generator
                .y(function (d) { return yScale(d.cases) }) // set the y values for the line generator

          // 8. An array of objects of length N. Each object has key -> value pair, the key being "y" and the value is a random number

          // 1. Add the SVG to the page and employ #2
          var svg = linechart
                .append('div')
                .attr('class', 'flexWrapper')
                .append('svg')
                .attr('width', width + margin.left + margin.right)
                .attr('height', height + margin.top + margin.bottom)

          var chart = svg.append('g')
                .attr('id', 'linechart')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

          svg.append('text')
            .attr('class', 'linechartTitle')
            .attr('x', 0)
            .attr('y', margin.top / 2 + 12)
            .text(data[0].area)

          // 3. Call the x axis in a group tag
          chart.append('g')
                .attr('class', 'xAxis')
                .attr('transform', 'translate(0,' + height + ')')
                .call(xAxis)

          // 4. Call the y axis in a group tag
          chart.append('g')
                .attr('class', 'yAxis')
                .call(yAxis)
                .call(g => g.select('.domain')
                    .remove())
                .call(g => g.selectAll('.tick:not(:first-of-type) line')
                    .attr('stroke-opacity', 0.5)
                    .attr('stroke-dasharray', '1,1'))
                .call(g => g.selectAll('.tick text')
                    .attr('x', -2)
                    .attr('dy', 2)
                    .style('text-anchor', 'end'))

          // 9. Append the path, bind the data, and call the line generator
          chart.append('path')
                .datum(data) // 10. Binds data to the line
                .attr('class', 'line') // Assign a class for styling
                .attr('d', line) // 11. Calls the line generator
        }

        drawChart(china)
        drawChart(othersSummarized)
      })
    }
  },
  mounted () {
    setTimeout(() => {
      this.initCode()
    }, 200)
  }
}
</script>
<style lang="scss">
.line {
  fill: none;
  stroke: #D4883D;
  stroke-width: 2px;
}

.tick text {
    font-family: $font-CuratorRegular;
    font-size: 12px;
    @include breakpoint($d_medium) {
      font-size: 12px;
    }
}

#linechartWrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
}

.linechartTitle {
    font-family: $font-CuratorBold;
    font-size: 24px;
}
</style>
